{
  "version": 1,
  "asset_id": "5ea18766-3e09-4c93-8a00-274e2777a820",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/5ea18766-3e09-4c93-8a00-274e2777a820/cert-mapa.jpg",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/5ea18766-3e09-4c93-8a00-274e2777a820/cert-mapa.jpg",
  "original_filename": "cert-mapa.jpg",
  "size": 20074,
  "content_type": "image/jpeg",
  "created_at": "2026-09-22T12:21:11Z"
}
